export default __webpack_public_path__ + "static/media/card-home-icon.35d7b767.png";